import { render, staticRenderFns } from "./StockOrderHeader.vue?vue&type=template&id=21d9d430&scoped=true"
import script from "./StockOrderHeader.vue?vue&type=script&lang=ts"
export * from "./StockOrderHeader.vue?vue&type=script&lang=ts"
import style0 from "./StockOrderHeader.vue?vue&type=style&index=0&id=21d9d430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d9d430",
  null
  
)

export default component.exports